import { render } from "./DashboardStats.vue?vue&type=template&id=54088adc&scoped=true"
import script from "./DashboardStats.vue?vue&type=script&lang=js"
export * from "./DashboardStats.vue?vue&type=script&lang=js"

import "./DashboardStats.vue?vue&type=style&index=0&id=54088adc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54088adc"]])

export default __exports__